<template>
  <div class="min-w-max-content">
    <el-date-picker
      class="dashboard-date-picker cursor-pointer"
      :value="dateRange"
      type="daterange"
      align="right"
      unlink-panels
      start-placeholder="Start date"
      end-placeholder="End date"
      :default-time="['00:00:00', '23:59:59']"
      :picker-options="pickerOptions"
      @input="handlePick"
      :clearable="false"
    >
      <span class="text-gray-400 font-semibold" slot="range-separator"> - </span>
    </el-date-picker>
  </div>
</template>

<script>
import { timeDay, timeWeek, timeMonth, timeYear } from 'd3-time';
import { getDateEndpoints } from '@/helpers/date-utils';

export default {
  name: 'DatePicker',
  props: {
    dateRange: Array,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: 'Last 7 days',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeDay.offset(endDate, -6);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'Last 30 days',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeDay.offset(endDate, -29);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'Last 90 days',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeDay.offset(endDate, -89);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'This Week',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeWeek.floor(endDate);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'This Month',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeMonth.floor(endDate);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
          {
            text: 'This Year',
            onClick(picker) {
              const endDate = new Date();
              const startDate = timeYear.floor(endDate);
              picker.$emit('pick', getDateEndpoints([startDate, endDate]));
            },
          },
        ],
      },
    };
  },
  methods: {
    handlePick(value) {
      this.$emit('change', value);
    },
  },
};
</script>

<style lang="scss">
.dashboard-date-picker {
  max-width: 250px;
  @apply border-white;
  @apply border-2;
  @apply border-solid;
  @apply rounded-lg;
  .el-range-input {
    @apply font-semibold;
    width: 48%;
  }
  .el-range-separator {
    @apply font-semibold;
  }
  .el-range__icon {
    @apply font-bold;
    @apply text-gray-600;
    @apply text-lg;
    @apply mt-1;
  }
  .el-range__close-icon {
    @apply hidden;
  }
}
</style>
